<template>
  <el-header class="nav-header">
    <!-- 公司Logo（餐饮SaaS专属标识） -->
    <div class="header-main">
      <div class="logo">
        <h2 style="color: #e6a23c">麦田熊科技有限公司</h2>
      </div>
      <!-- 导航菜单（贴合餐饮SaaS业务） -->
      <el-menu
        :default-active="activeAnchor"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleMenuSelect"
        text-color="#333"
        active-text-color="#E6A23C"
      >
        <el-menu-item index="home">首页</el-menu-item>
        <el-menu-item index="about">关于我们</el-menu-item>
        <el-menu-item index="product">产品服务</el-menu-item>
        <el-menu-item index="case">客户案例</el-menu-item>
      </el-menu>
    </div>
  </el-header>
</template>

<script>
export default {
  name: "NavBarComp",
  data() {
    return {
      activeAnchor: "home",
      // 锚点映射配置
      navItems: [
        { id: "home", title: "首页", sectionId: "home-section" },
        { id: "about", title: "关于我们", sectionId: "about-section" },
        { id: "product", title: "产品服务", sectionId: "product-section" },
        { id: "case", title: "客户案例", sectionId: "case-section" },
      ],
      scrollTimer: null,
    };
  },

  computed: {
    navbarHeight() {
      return document.querySelector(".navbar")?.offsetHeight || 64;
    },
  },

  mounted() {
    // 监听滚动
    window.addEventListener("scroll", this.handleScroll);

    // 初始化检查URL hash
    this.initFromUrlHash();

    // 初始设置激活项
    this.updateActiveAnchor();
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
  },

  methods: {
    // 从URL hash初始化
    initFromUrlHash() {
      if (this.$route.hash) {
        const hash = this.$route.hash.substring(1);
        const navItem = this.navItems.find((item) => item.sectionId === hash);
        if (navItem) {
          this.activeAnchor = navItem.id;
        }
      }
    },

    // 处理滚动
    handleScroll() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);

      this.scrollTimer = setTimeout(() => {
        this.updateActiveAnchor();
      }, 100);
    },

    // 更新激活的锚点
    updateActiveAnchor() {
      const scrollPosition = window.scrollY + this.navbarHeight + 50;
      let activeId = "home";

      // 从下往上检查，确保正确激活
      for (let i = this.navItems.length - 1; i >= 0; i--) {
        const item = this.navItems[i];
        const element = document.getElementById(item.sectionId);
        if (element) {
          const offsetTop = element.offsetTop;

          if (scrollPosition >= offsetTop) {
            activeId = item.id;
            break;
          }
        }
      }

      if (activeId !== this.activeAnchor) {
        this.activeAnchor = activeId;
      }
    },

    // 处理菜单选择
    handleMenuSelect(anchorId) {
      this.scrollToAnchor(anchorId);
    },

    // 滚动到锚点
    scrollToAnchor(anchorId) {
      const navItem = this.navItems.find((item) => item.id === anchorId);
      if (!navItem) return;

      // 更新激活状态
      this.activeAnchor = anchorId;

      // 获取目标元素
      const element = document.getElementById(navItem.sectionId);
      if (!element) {
        console.warn(`未找到元素: #${navItem.sectionId}`);
        return;
      }

      // 计算滚动位置（考虑导航栏高度）
      const targetPosition = element.offsetTop - this.navbarHeight;

      // 平滑滚动
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });

      // 更新URL（不添加历史记录）
      this.updateUrlHash(navItem.sectionId);

      // 触发事件
      this.$emit("nav-click", anchorId, navItem.sectionId);
    },

    // 更新URL hash
    updateUrlHash(sectionId) {
      // 使用replaceState避免添加历史记录
      const newUrl = `${window.location.pathname}#${sectionId}`;
      history.replaceState(null, null, newUrl);
    },

    // 滚动到顶部
    scrollToTop() {
      this.activeAnchor = "home";
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      history.replaceState(null, null, window.location.pathname);
    },
  },
};
</script>

<style scoped lang="less">
.nav-header {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99;
  height: 80px !important;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .header-main {
    margin: 0 auto;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .logo {
      margin-right: 30px;
    }
  }
  .el-menu.el-menu--horizontal {
    border-bottom: none !important;
  }
}
</style>
